import React from 'react';

import { getApplicationFormProgress } from '@app/redux/applicationForm/applicationForm.selectors';
import { getApplicationDetails } from '@app/redux/applications/applications.selectors';
import { useAppSelector } from '@app/redux/hooks';

import { Grid } from '@mui/material';

import DetailsSection from '@pages/Applications/containers/ApplicationAccountDetails/components/DetailsSection';
import InfoSection from '@pages/Applications/containers/ApplicationAccountDetails/components/InfoSection';
import WelcomeSection from '@pages/Applications/containers/ApplicationAccountDetails/components/WelcomeSection';

import withApplicationValidations from './hocs/withApplicationValidations';
import { StyledApplicationAccountDetails } from './styles';

function ApplicationAccountDetails({
	applicationStatusRefresh,
}: {
	showLoader?: boolean;
	applicationStatusRefresh: ({
		applicationId,
		formId,
		formVersion,
	}: {
		applicationId: number;
		formId: number;
		formVersion?: number | null | undefined;
	}) => Promise<void>;
}) {
	const applicationDetails = useAppSelector(getApplicationDetails);
	const applicationFormProgress = useAppSelector(getApplicationFormProgress);

	if (!applicationDetails) return <></>;

	return (
		<StyledApplicationAccountDetails>
			<Grid item xs={12} sm={6} md={3} order={{ sm: 1, md: 1 }}>
				<InfoSection
					applicationDetails={applicationDetails}
					applicationStatusRefresh={() =>
						applicationStatusRefresh({ applicationId: applicationDetails.id, formId: applicationDetails.form_id })
					}
					progressPercentage={
						Math.round(
							(applicationFormProgress.values.total.answered / applicationFormProgress.values.total.required) * 1000,
						) / 10
					}
				/>
			</Grid>

			<Grid item xs={12} sm={12} md={5} order={{ sm: 3, md: 2 }}>
				<DetailsSection applicationDetails={applicationDetails} />
			</Grid>

			<Grid item xs={12} sm={6} md={4} order={{ sm: 2, md: 3 }}>
				<WelcomeSection applicationDetails={applicationDetails} />
			</Grid>
		</StyledApplicationAccountDetails>
	);
}

export default withApplicationValidations(ApplicationAccountDetails);
